import RenderingLayout from './RenderingLayout';

export default RenderingLayout;
